import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsDown,
  faThumbsUp,
  faCheck
} from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

const rectangleUrl = `/wp-content/themes/teamconnector2/assets/images/Rectangle-45.png`;
const leverhouse2Url = `/wp-content/themes/teamconnector2/assets/images/leverhouse2.png`;
const arrowUrl = `/wp-content/themes/teamconnector2/assets/images/arrow.png`;
const pointerUrl = `/wp-content/themes/teamconnector2/assets/images/Pointer.png`;
const sparkle1Url = `/wp-content/themes/teamconnector2/assets/images/Sparkle-1.png`;
const sparkle2Url = `/wp-content/themes/teamconnector2/assets/images/Sparkle-2.png`;
const sparkle3Url = `/wp-content/themes/teamconnector2/assets/images/Sparkle-3.png`;
const leverhandleOverlayUrl = `/wp-content/themes/teamconnector2/assets/images/leverhandle-overlay.png`;
const paceIndikatorUrl = `/wp-content/themes/teamconnector2/assets/images/Pace-Indicator.png`;

/**
 * Button Component with color and background customization
 */
const WheelLever = React.forwardRef(
  (
    {
      diameter,
      onClick = () => {},
      className,
      disabled = false,
      type,
      isSpinning,
      isLevel,
      isOpenQuestion
    },
    ref
  ) => {
    const { t } = useTranslation();
    const thisClassName = `v2-wheel-lever__handle ${className}`;
    const buttonStyle = {
      width: diameter
    };

    const leverText = window.wheel_coloring.handlebar_lever_text;
    const feedbackText = window.wheel_coloring.handlebar_feedback_text; 
    const [levelMessage, setLevelMessage] = useState(t("Time to wheel"));

    useEffect(() => {
      if (isLevel === "LOW") {
        setLevelMessage(feedbackText);
      }

      if (isLevel === "MEDIUM") {
        setLevelMessage(feedbackText);
      }

      if (isLevel === "HIGH") {
        setLevelMessage(feedbackText);
      }
    }, [isLevel]);

    const taglineFeedback = isLevel => {
      // if (isLevel === "LOW") {
      //   return (
      //     <FontAwesomeIcon
      //       className="feedback-lever-icon"
      //       icon={faThumbsDown}
      //       style={{ color: "#fff" }}
      //     />
      //   );
      // }
      // if (isLevel === "MEDIUM") {
      //   return (
      //     <FontAwesomeIcon
      //       className="feedback-lever-icon"
      //       icon={faThumbsUp}
      //       style={{ color: "#fff" }}
      //     />
      //   );
      // }
      if (isLevel === "HIGH") {
        return (
          <FontAwesomeIcon
            className="feedback-lever-icon"
            icon={faCheck}
            style={{ color: "#fff" }}
          />
        );
      }
    };

    return (
      <div className="v2-wheel-lever">
        <div className="v2-wheel-lever-container">
          <div className="v2-wheel-lever-connector">
            <picture>
              <source srcSet={rectangleUrl} type="image/png" />
              <img src={rectangleUrl} alt="Union" />
            </picture>
          </div>
          <div className="v2-wheel-lever-house">
            <picture>
              <source srcSet={leverhouse2Url} type="image/png" />
              <img src={leverhouse2Url} alt="Union" />
            </picture>
            <div className="tagline">
              {isSpinning || isOpenQuestion ? (
                taglineFeedback(isLevel)
              ) : (
                <span className="tagline-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="428" height="230" viewBox="0 0 428 230">
                    <path id="Polygon_1" data-name="Polygon 1" d="M214,0,428,230H0Z" fill="currentColor"/>
                  </svg>
                </span>
              )}

              {isSpinning ? (
                <p className="tagline-message">{levelMessage}</p>
              ) : (
                <p className="tagline-yellow">{leverText}</p>
              )}
            </div>
            <div
              className={thisClassName}
              style={buttonStyle}
              onClick={onClick}
              disabled={disabled}
              type={type}
            >
              <picture
                className={`pointer ${
                  isSpinning || isOpenQuestion ? "active" : ""
                }`}
              >
                <img src={pointerUrl} alt="pointer" className="pointer-icon" />
              </picture>
              <picture
                className={`sparkle ${
                  isSpinning || isOpenQuestion ? "active" : ""
                }`}
              >
                <img src={sparkle1Url} alt="sparkle" className="sparkle-1" />
                <img src={sparkle2Url} alt="sparkle" className="sparkle-2" />
                <img src={sparkle3Url} alt="sparkle" className="sparkle-3" />
              </picture>

              <svg
                className="handleBase"
                width="43"
                height="148"
                viewBox="0 0 43 148"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.5 35C31.165 35 39 27.165 39 17.5C39 7.83502 31.165 0 21.5 0C11.835 0 4 7.83502 4 17.5C4 27.165 11.835 35 21.5 35ZM15.5 37.5001C14.4894 37.2113 13.594 36.7663 12.8029 36.2131C10.7286 46.5416 7.05805 64.7812 6.13551 69.1285C4.82992 75.2808 13.3505 77.7128 14.8851 70.8943C15.9702 66.0732 19.5778 48.0079 21.5983 37.8377C19.6486 38.1571 17.5528 38.0866 15.5 37.5001Z"
                  fill="currentColor"
                />
              </svg>

              <picture className="handleOverlay">
                <source srcSet={leverhandleOverlayUrl} type="image/png" />
                <img src={leverhandleOverlayUrl} alt="Union" />
              </picture>
            </div>

            <div className="v2-wheel-lever-gauge">
              <div className="v2-wheel-lever-gauge__bar" />
              <div
                ref={ref}
                className={`v2-wheel-lever-gauge__indicator ${
                  isSpinning || isOpenQuestion ? "active" : ""
                }`}
              >
                <picture>
                  <source srcSet={paceIndikatorUrl} type="image/png" />
                  <img src={paceIndikatorUrl} alt="Union" />
                </picture>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

WheelLever.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["submit"])
};

export default WheelLever;
